import CheckIcon from '@mui/icons-material/Check'
import React from 'react'
import {useTranslation} from 'react-i18next'

import {COMMON_FILTERS_WIDGET_NAMESPACE} from '../consts'

import {FilterActionButton} from './FilterActionButton'

type SelectAllFilterButtonProps = {
  onClick: () => void
  keyName: string
}

export const SelectAllFilterButton: React.FC<SelectAllFilterButtonProps> = ({onClick, keyName}) => {
  const {t} = useTranslation(COMMON_FILTERS_WIDGET_NAMESPACE)
  return (
    <FilterActionButton
      sx={{
        marginTop: '10px'
      }}
      variant="text"
      onClick={onClick}
      startIcon={<CheckIcon />}
      data-test-id={`select-all-filter-button-${keyName}`}
    >
      {t('label.selectAll')}
    </FilterActionButton>
  )
}
